import React, { useState, useRef, useCallback } from 'react';
import { Carousel } from 'antd';
import { RightOutlined } from '@ant-design/icons';

const ADVANTAGES = [
  {
    id: 'low-moq',
    title: '宠物小单零门槛混批',
    icon: '🛍️',
    summary: '打破宠物行业传统整箱拿货规则，支持单包猫粮、单瓶洗护散拿，支持跨品牌、跨品类混批，无起订要求',
    description: '打破宠物行业传统整箱拿货规则，支持单包猫粮、单瓶洗护散拿，支持跨品牌、跨品类混批，无起订要求，适配各大宠物店，宠物医院、猫咖狗咖，家庭繁育舍等，避免门店库存积压、临期损耗。市面上多数宠物 B2B 平台要求整箱起订，魔鬼鱼订货平台放宽起订标准，支持一件起订',
  },
  {
    id: 'geo-control',
    title: '完善的货品区域 & 渠道管控技术能力',
    icon: '🌐',
    summary: '区域精准管控：可设置货品专属供货区域，限定仅指定地区门店可采购，屏蔽其他区域查看权限',
    description: '区域精准管控：可设置货品专属供货区域，限定仅上海，长沙等指定地区门店可采购，屏蔽其他区域查看权限；渠道定向隔离：区分渠道类型，按需开放宠物医院、线下宠物店等专属采购权限；底层技术隔离机制：不符合渠道资质的门店，系统自动隐藏对应货品，无查看、下单权限，杜绝串货、乱价，维护各区域经销商权益',
  },
  {
    id: 'stable-supply',
    title: '稳定供给，全国可发',
    icon: '🚚',
    summary: '海量优质供应商全域入驻，货源供给稳定充足，平台汇聚全国 200 余家正规宠物品类供应商',
    description: '海量优质供应商全域入驻，货源供给稳定充足 平台汇聚全国 200 余家正规宠物品类供应商，品牌方等仓储网点覆盖全国各区域，货源储备充沛，供货能力强劲。全链路标准化履约体系保障下单后 48 小时内快速安排发货，高效缩短商家备货等待周期。同时搭载数字化物流提醒系统，订单出库发货后，系统将自动通过商家服务号弹窗推送物流单号与运输节点信息，货品中转、派送等全流程动态实时更新，商家无需反复查询，一键即可掌握完整物流进度，订货对账更省心。',
  },
  {
    id: 'escrow',
    title: '担保交易，资金安全',
    icon: '🛡️',
    summary: '平台专属宠物 B2B 担保交易体系，全方位守护商家资金安全',
    description: '平台专属宠物 B2B 担保交易体系，全方位守护商家资金安全 平台搭建合规完善的第三方担保交易机制，买卖双方货款全程平台托管，规避线下现款现货、私下转账带来的拖欠货款、货不对款、卷款失联等经营风险。门店采购货款先由平台担保留存，待商家确认收货、货品验收无误后，再完成货款结算给供应商，交易链路清晰可追溯。全流程资金流转留存电子凭证，资金链路透明合规，杜绝交易资金纠纷，让门店进货、供应商供货都无资金后顾之忧。',
  },
];

const Advantages = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);

  const handleBeforeChange = useCallback((from, to) => {
    setActiveIndex(to);
  }, []);

  const handleCardClick = useCallback((index) => {
    setActiveIndex(index);
    if (carouselRef.current) {
      carouselRef.current.goTo(index);
    }
  }, []);

  const activeAdvantage = ADVANTAGES[activeIndex];

  return (
    <div className="advantages">
      <div className="container">
        <div className="advantages-layout">
          {/* Left: Title & Controls */}
          <div className="advantages-left">
            <h2 className="advantages-title-cn">我们能做什么？</h2>
            <p className="advantages-title-en">What can we do?</p>
            <div className="advantages-dots">
              {ADVANTAGES.map((_, idx) => (
                <span
                  key={idx}
                  className={`advantages-dot${idx === activeIndex ? ' advantages-dot--active' : ''}`}
                  onClick={() => handleCardClick(idx)}
                />
              ))}
            </div>
          </div>

          {/* Right: Card Carousel */}
          <div className="advantages-right">
            <Carousel
              ref={carouselRef}
              dots={false}
              autoplay
              autoplaySpeed={3000}
              slidesToShow={3}
              slidesToScroll={1}
              centerMode={false}
              beforeChange={handleBeforeChange}
              responsive={[
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ]}
            >
              {ADVANTAGES.map((item, idx) => (
                <div key={item.id} className="advantages-card-slide">
                  <div
                    className={`advantages-card${idx === activeIndex ? ' advantages-card--active' : ''}`}
                    onClick={() => handleCardClick(idx)}
                  >
                    <span className={`advantages-card-icon advantages-card-icon--${idx}`}>{item.icon}</span>
                    <h3 className="advantages-card-title">{item.title}</h3>
                    <p className="advantages-card-summary">{item.summary}</p>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>

        {/* Bottom: Detail description */}
        <div className="advantages-detail">
          <p className="advantages-detail-label">核心优势</p>
          <p className="advantages-detail-text">{activeAdvantage.description}</p>
        </div>
      </div>
    </div>
  );
};

export default Advantages;